import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getCustomerAddressDelete = createAsyncThunk(
  "customerAddressDeleteList/getCustomerAddressDelete",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/customerAddress/delete`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const customerAddressDeleteSlice = createSlice({
  name: "customerAddressDeleteList",
  initialState: {
    loading: false,
    customerAddressDeleteData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCustomerAddressDelete.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCustomerAddressDelete.fulfilled, (state, action) => {
        state.loading = false;
        state.customerAddressDeleteData = action.payload;
      })
      .addCase(getCustomerAddressDelete.rejected, (state, action) => {
        state.loading = false;
        state.customerAddressDeleteData = action.payload;
        state.error = action.payload;
      });
  },
});

export default customerAddressDeleteSlice.reducer;
